import { render, staticRenderFns } from "./details-page.vue?vue&type=template&id=442c8adc&scoped=true"
import script from "./details-page.vue?vue&type=script&lang=js"
export * from "./details-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c8adc",
  null
  
)

export default component.exports